import React, { useState, useRef, useEffect } from 'react';
import useOnclickOutside from 'react-cool-onclickoutside';

const ListOptions = ({
  id,
  cssClass,
  selectRef,
  title,
  setSelectedOption,
  selectedOption,
  list,
  initVal,
  defaultText = '-',
}) => {
  if (list) {
    const checkboxRef = useRef(null);
    const wrapperRef = useOnclickOutside(() => {
      checkboxRef.current.checked = false;
    });
    const [currentLastOption, setCurrentLastOption] = useState({});
    const [currentSelectedOption, setCurrentSelectedOption] = useState({});
    const selectChange = (e, option) => {
      e.preventDefault();
      setSelectedOption(option);
      setCurrentLastOption(option);
      checkboxRef.current.checked = false;
      setCurrentSelectedOption(option);
    };

    useEffect(() => {
      const selectedVal = list?.find((x) => x.selected == true);
      if (
        !list?.some(
          (x) => x.value.toLowerCase() === selectedOption?.value?.toLowerCase()
        ) &&
        !selectedVal
      ) {
        setCurrentSelectedOption({});
      } else {
        const selectedVal = list?.find((x) => x.selected == true);
        setCurrentSelectedOption(selectedVal ? selectedVal : selectedOption);
      }
    }, [list]);

    useEffect(() => {
      if (list && initVal?.value) {
        const selectedObj = list?.find(
          (x) => x.value?.toLowerCase() === selectedOption?.value?.toLowerCase()
        );
        if (selectedObj) {
          setCurrentSelectedOption(selectedObj);
        }
      }
    }, [initVal]);

    if (list) {
      return (
        <div className="find-my-part__select-wrapper" ref={wrapperRef}>
          <h3 className={`product-info__variants-header ${cssClass}`}>
            {title}
          </h3>
          <section className="product-info__variants">
            <label
              htmlFor={id}
              className={`${list?.length < 1 ? 'disabled' : ''}`}
            >
              {currentSelectedOption?.text || defaultText}
            </label>
            <input
              type="checkbox"
              id={id}
              ref={checkboxRef}
              disabled={list?.length < 1}
              className="hides product-info__variants-toggler"
            />
            <ul className="product-info__variants-list" ref={selectRef}>
              {list.map((option, optionIndex) => (
                <li key={`${id}_${optionIndex}`}>
                  <a href="#" onClick={(e) => selectChange(e, option)}>
                    {option.text}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        </div>
      );
    }
  }
  return null;
};
export default React.memo(ListOptions);
